(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["inventory-count"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__sfInvHook) return;
    window.__sfInvHook = true;
    document.addEventListener('variant:update', function (e) {
      var html = e.detail && e.detail.data && e.detail.data.html;
      if (!html) return;
      var fresh = html.querySelector('[data-sf-inventory-count]');
      if (!fresh) return;
      document.querySelectorAll('[data-sf-inventory-count]').forEach(function (el) {
        if (fresh.dataset.productId && el.dataset.productId && fresh.dataset.productId !== el.dataset.productId && !(e.detail.data.newProduct)) return;
        el.innerHTML = fresh.innerHTML;
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
